// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GXvs9Gq91ReyNm8ckP3t{padding-left:15px;padding-right:15px;margin-bottom:20px}`, "",{"version":3,"sources":["webpack://./Scripts/app/components/senha-vendedor/senha-vendedor.module.scss"],"names":[],"mappings":"AAEA,sBAEQ,iBAAA,CACA,kBAAA,CAEJ,kBAAA","sourcesContent":["@use '../../estilos/base';\r\n\r\n.dica {\r\n    padding: {\r\n        left: 15px;\r\n        right: 15px;\r\n    }\r\n    margin-bottom: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dica": `GXvs9Gq91ReyNm8ckP3t`
};
export default ___CSS_LOADER_EXPORT___;
